import { useFormik } from "formik";
import * as Yup from "yup";
import { EntryStatusIds } from "../../../modules/EntryRequests/types";

interface useEntryGestorUpdateValidator {
    onSubmit: (values: any) => void;
}

export const entryGestorUpdateValidator = Yup.object({
    status_element_id: Yup.string().required("Estado del elemento es Requerido"),
    quantity_received: Yup.number().min(1, "Cantidad debe ser mayor a 0").required("Cantidad es Requerido"),
    observations: Yup.string().nullable(),
    ids: Yup.array()
    .of(Yup.number()),
})
export const useEntryGestorUpdateValidator = ({ onSubmit }: useEntryGestorUpdateValidator) => {
    return useFormik({
        initialValues: {
            status_element_id: '',
            quantity_received: null,
            observations: '',
            ids: [],
        },
        validationSchema: entryGestorUpdateValidator,
        onSubmit,
    })
}
//Status id
export const entryGestorStatusolicitud = Yup.object({
    status_id: Yup.string().required("Estado de la solicitud es requerido"),
    reason: Yup.string().required("El motivo es requerido")
})
export const useEntryGestorStatusolicitud = ({ onSubmit }: useEntryGestorUpdateValidator) => {
    return useFormik({
        initialValues: {
            status_id: '',
            reason: ''
        },
        validationSchema: entryGestorStatusolicitud,
        onSubmit,
    })
}

export const useConceptsSolicitud = ({ onSubmit }: useEntryGestorUpdateValidator) => {
    return useFormik({
        initialValues: {
            status_id: '',
            observations: '',
            reason: '',
            items: [],
        },
        onSubmit,
    })
}